import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { EmopFormProClass } from '../../class/EmopFormProClass/EmopFormProClass';

@Component({
  selector: 'emop-public-doc-create',
  templateUrl: './emop-public-doc-create.component.html',
  styleUrls: ['./emop-public-doc-create.component.scss']
})
export class EmopPublicDocCreateComponent implements OnInit {

  // EmopFormData = new EmopFormProClass([
  //   {
  //     alias: '文档名称',
  //     mode: 'str',
  //     key: 'name',
  //     value: '',
  //     disabled: true,
  //     validate: ['required']
  //   },
  //   {
  //     alias: '文档模板',
  //     mode: 'lov',
  //     key: '$doc_template',
  //     value: '',
  //     options: [],
  //     validate: ['required'],
  //     // onChange: this.changeFn.bind(this)
  //   }
  // ]);
  // dictionaries = [];
  // dataTypeId = '';
  // dataTypeName = '';
  // dataTypeAlias = '';
  // docTemplateData = {};
  // @Input() loading: boolean = true;
  // @Input() folderId: string;
  // @Input() type: 'AY8_NP_Template' | 'AY8_Template';
  // @Output() close = new EventEmitter();
  constructor(
    // private DocumentService: DocumentService,
    // private DataTypeService: DataTypeService,
    // private emop: EmopUtilsService,
    // private FolderService: FolderService
  ) { }

  ngOnInit(): void {
    // if (this.type === 'AY8_NP_Template') this.EmopFormData[0].disabled = false;
    // this.getTemplateData();
  }
  // getTemplateData() {
  //   this.DocumentService.findDocTemplateByTemplateType(this.type).subscribe((rs) => {
  //     if (rs.status === 200) {        this.loading = false;
  //       this.docTemplateData = rs.data;
  //       for (const key in rs.data) {
  //         this.EmopFormData.find(item => item.key === '$doc_template').options.push({
  //           key,
  //           val: key
  //         });
  //         this.dictionaries.push({
  //           key,
  //           val: rs.data[key].properties.ay8_document_type
  //         })
  //       }
  //     }
  //   });
  // }
  /**
   * $doc_template字段修改的回调
  //  * @param param0 
   */
  // changeFn({value}) {
  //   if(this.type==='AY8_NP_Template') {
  //     const originVal = this.EmopFormData[0].value.split('@')
  //     this.EmopFormData[0].value = originVal[0] + '@' + value
  //   }else {
  //     this.EmopFormData[0].value = '@' + value
  //   }
  //   const zhValue = value
  //   value = this.dictionaries.find(item=>item.key===value).val
  //   this.DataTypeService.findDataTypeByName(value.replace('Revision', '')).subscribe((rs) => {
  //     let docTemplateSelectedData;
  //     docTemplateSelectedData = this.docTemplateData[zhValue];
  //     let ay8_prefix = docTemplateSelectedData?.properties?.ay8_prefix
  //     this.EmopFormData.length = 2
  //     rs.data.attributes?.forEach(item => {
  //       if(item.type === '_lov') {
  //         item.options.map(p=>{
  //           let temp  = p.key
  //           p.key = p.val
  //           p.val = temp
  //           return p
  //         })
  //       }
  //       this.EmopFormData.push({
  //         ...item,
  //         // 置值顺序: 路由参数>模板属性>默认值
  //         value: this.emop.getRouteQueryParams()[item.name]  || docTemplateSelectedData.properties[item.name] ||item['defaultVal'] || item['value'] || null,
  //         placeholder: '请输入' + item.alias,
  //         //@ts-ignore
  //         mode: item.type.split('_')[1],
  //         allowClear: true,
  //         key: item.name,
  //         validate: ['project_ids', 'project_list'].includes(item.name) ? ['required'] : [],
  //         onChange: ['project_ids', 'project_list'].includes(item.name) && this.onChangeFn.bind(this)
  //       });
  //     })
  //     console.log(this.EmopFormData)
  //     const item_id = this.EmopFormData.find(item=>item.key === 'item_id')
  //     if(item_id) item_id.value = ay8_prefix
  //     this.dataTypeId = rs.data.id;
  //     this.dataTypeAlias = rs.data.alias;
  //     this.dataTypeName = rs.data.name;
  //     if(location.href.includes('/outlink/template') && this.type === 'AY8_Template') this.onChangeFn()
  //   });
  // }
  /**
   * project_ids, project_list 修改的回调
   */
  // onChangeFn() {
  //   const attributeForms = this.EmopFormData.getData()
  //   let name = ''
  //   if(this.type === 'AY8_Template') {
  //     name = attributeForms['project_ids'] +  '-' + attributeForms['project_list'] + '@' + attributeForms['$doc_template']
  //   }else {
  //     name = attributeForms['name'] + '@' +  attributeForms['$doc_template']
  //   }
  //   this.EmopFormData[0].value = name.replace('null','')
  // }
  // cancel() {
  //   this.close.emit(false)
  // }
  // submit() {
  //   if (this.EmopFormData.validate()) {
  //     this.loading = true
  //     let attributeForms = this.EmopFormData.getData();
  //     let params = {
  //       attributeForms,
  //       name: attributeForms['name'],
  //       folderId: this.folderId,
  //       dataTypeId: this.dataTypeId,
  //       dataTypeName: this.dataTypeName,
  //       dataTypeAlias: this.dataTypeAlias,
  //       properties: {},
  //       relationType: 'IMAN_specification'
  //     };
  //     if(Object.keys(params.attributeForms).includes('doc_template')) {
  //       params.attributeForms['doc_template'] = this.EmopFormData[1].value
  //     }
  //     // 要删除的字段
  //     ['$doc_template', 'name'].forEach(item => {
  //       delete params.attributeForms[item];
  //     });
  //     params.properties = params.attributeForms
  //     params.attributeForms = JSON.stringify(params.attributeForms)
  //     console.log(params);
  //     this.loading = true
  //     this.FolderService.getFolderDetail(this.folderId).subscribe((rs) => {
  //       this.DocumentService.createFromTemplate({
  //         ...params,
  //         isTemplate: rs.data?.isTemplate || false,
  //         isEnable: rs.data?.isEnable || false,
  //         isInheritanceAcl: rs.data?.isInheritanceAcl || false,
  //         isNeedSync: rs.data?.isNeedSync || false,
  //       }).subscribe((rs) => {
  //         this.loading = false
  //         if(rs.status===200) {
  //           this.emop.message('success', '创建成功')
  //           this.close.emit(rs.data)
  //         }else {
  //           this.emop.message('info',rs.message)
  //         }
  //       })
  //     })

  //   }
  // }
}
